class FeaturedCollection {
  constructor() {
    this.init();
  }

  init() {
    this.initAddToCartButtons();
  }

  initAddToCartButtons() {
    document.querySelectorAll('.product-card__add-to-cart').forEach(button => {
      button.addEventListener('click', this.handleAddToCart.bind(this));
    });
  }

  async handleAddToCart(event) {
    const button = event.currentTarget;
    const form = button.closest('form');
    const productId = button.dataset.productId;
    
    if (!productId) return;

    try {
      button.disabled = true;
      const formData = new FormData(form);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Failed to add item to cart');

      // Trigger cart update event
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Show success message
      this.showMessage('Item added to cart', 'success');
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showMessage('Failed to add item to cart', 'error');
    } finally {
      button.disabled = false;
    }
  }

  showMessage(message, type = 'success') {
    // Implement your preferred notification system here
    console.log(`${type}: ${message}`);
  }
}

// Initialize featured collection when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FeaturedCollection();
}); 